import http from '../../../../common/utils/http'
import apiUtils from '../../../../common/utils/apiUtils'
import { API_BASE_URL } from '../../../../common/utils/commonUrl'

export default {
  searchInfoByData: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getCouponExampleBuyList`, { params: data }).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getCouponInfoById: (id) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getCouponListByBuyId`, { params: id }).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getCancelRecord: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getEmployeeVerifySalesDTOList`, { params: data }).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/go-out-management/my-record/my-record.js